import { CrossIcon } from '@eleveo/icons-react';
import { Button, Col, Row } from '@zoom/components';
import { FormApi } from 'final-form';
import { TFunction } from 'i18next';
import React from 'react';
import { Form, Field, FormRenderProps, FormSpy } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import { finalFormDeBouncedInputHelper } from '../../components/Inputs/DeBouncedInput';
import { max255chars } from '../../utils/validations';
import {
  getSearchFieldsInputTag,
  SEARCH_REAL_TIME_ADHERENCE_CONTAINER_TAG,
  SEARCH_REAL_TIME_ADHERENCE_RESET_BUTTON_TAG,
} from './constants';

interface RealTimeAdherenceHeaderFilter {
  name: string;
}

export type RealTimeAdherenceHeaderFilterType = Partial<RealTimeAdherenceHeaderFilter>;

interface RealTimeAdherenceHeaderSearchFormProps {
  onSubmit: (values: RealTimeAdherenceHeaderFilterType, form: FormApi<RealTimeAdherenceHeaderFilterType>) => void;
}

const agentNameField = (t: TFunction) =>
  finalFormDeBouncedInputHelper({
    label: t('filter.searchByName'),
    type: 'text',
    dataTestId: getSearchFieldsInputTag('search-name'),
  });

export const RealTimeAdherenceHeaderSearchForm: React.FC<RealTimeAdherenceHeaderSearchFormProps> = ({ onSubmit }) => {
  const { t } = useTranslation();

  const realTimeAdherenceHeaderSearchFormRenderer = ({ values, handleSubmit }: FormRenderProps) => (
    <form>
      <FormSpy
        subscription={{ values: true }}
        onChange={({ values: newValues }) => {
          if (values.name === newValues.name) {
            // skip submitting same values (prevents error on initial load)
            return;
          }

          handleSubmit();
        }}
      />
      <Row data-test-id={SEARCH_REAL_TIME_ADHERENCE_CONTAINER_TAG}>
        <Col sm="auto">
          <Field name="name" render={agentNameField(t)} validate={max255chars} />
        </Col>
        <FormSpy subscription={{ dirty: true }}>
          {({ dirty, form: { reset } }) =>
            dirty && (
              <Col sm="auto">
                <Button
                  data-test-id={SEARCH_REAL_TIME_ADHERENCE_RESET_BUTTON_TAG}
                  kind="icon-bordered"
                  onClick={() => reset()}
                  title={t('filter.resetFilter')}
                >
                  <CrossIcon />
                </Button>
              </Col>
            )
          }
        </FormSpy>
      </Row>
    </form>
  );

  return <Form onSubmit={onSubmit} render={realTimeAdherenceHeaderSearchFormRenderer} />;
};
